import { render, staticRenderFns } from "./StockTransferPreview.vue?vue&type=template&id=e74fce0a"
import script from "./StockTransferPreview.vue?vue&type=script&lang=js"
export * from "./StockTransferPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports